import { makeStyles, tokens } from '@fluentui/react-components';

export const previewClipchampVideoModalStyles = makeStyles({
  dialog: {
    '@media screen and (max-width: 1280px)': {
      maxWidth: '600px',
    },
    '@media screen and (min-width: 1281px)': {
      maxWidth: '830px',
    },
  },
  dialogContentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: tokens.spacingHorizontalXXXL,
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  textGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingHorizontalS,
  },
  errorMsg: {
    color: tokens.colorStatusDangerForeground1,
  },
  dialogContent: {
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  messageBar: {
    maxWidth: '100%',
  },
});
